module.exports = __webpack_public_path__ + "assets/OctagonBySideDetailed.2833f9f4a485e182761ad20abeb28efa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/OctagonBySideDetailed.png
// module id = 541
// module chunks = 0